import { render } from "./poster-template-editor.vue?vue&type=template&id=70007a3e&scoped=true"
import script from "./poster-template-editor.vue?vue&type=script&lang=js"
export * from "./poster-template-editor.vue?vue&type=script&lang=js"

import "./poster-template-editor.vue?vue&type=style&index=0&id=70007a3e&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70007a3e"]])

export default __exports__